<template>
  <MRow class="my-5 items-center" :gutter="0">
    <MCol :size="3">
      <div class="flex flex-1 flex" style="word-break: break-all">
        <FlotoTriggerView
          icon-name="file-contract"
          :lable="`${$tc('order')} ${$tc('number')}`"
          :value="value.orderNumber || '---'"
        />
      </div>
    </MCol>
    <MCol :size="3">
      <FlotoTriggerView lable="cost" icon-name="money-bill">
        <template v-slot:lable>
          <span class="flex">
            {{ $tc('cost') }}
            (<CurrencyPicker
              :value="value.currencyId"
              text-only
              disabled
              style="white-space: nowrap"
            />)
          </span>
        </template>
        <template v-slot:value>
          <div v-if="value.totalCost" class="flex">
            {{ `${value.totalCost.toFixed(2)}` }}
            <CurrencyPicker :value="value.currencyId" text-only disabled />
          </div>
          <div v-else> --- </div>
        </template>
      </FlotoTriggerView>
    </MCol>
    <MCol :size="3">
      <FlotoTriggerView
        icon-name="calendar-alt"
        :lable="`${$tc('purchase')} ${$tc('required')} ${$tc('by')}`"
        :value="
          !value.requiredByTime
            ? '---'
            : value.requiredByTime | datetime(undefined, false)
        "
      />
    </MCol>
    <MCol :size="3">
      <FlotoTriggerView
        icon-name="calendar-alt"
        :lable="`${$tc('purchase')} ${$tc('order')} ${$tc('date')}`"
        :value="
          !value.orderedDate
            ? '---'
            : value.orderedDate | datetime(undefined, false)
        "
      />
    </MCol>
  </MRow>
</template>

<script>
import CurrencyPicker from '@components/data-picker/currency-picker'
import { OrganizationComputed } from '@state/modules/organization'
export default {
  name: 'SecondRow',
  components: { CurrencyPicker },
  model: {
    event: 'change',
  },
  props: {
    value: { type: Object, required: true },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
  },
  computed: {
    ...OrganizationComputed,
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
